/*eslint-disable*/
import _ from 'lodash';
import moment from 'moment';
import handleAppEvent from './event_engine';


let manageList = [];
let picklistdata = [];
let campaignManageData = [];
export const toTitleCase = (str) => {
  if (str && typeof str === 'string' && str.length > 2) {
    return str.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
  }

  return str;
};

export const formatPhoneNumber = (number) => {
  if ((number !== 0) && (number !== null) && (number !== '0')) {
    const number2 = (`${number}`).replace(/\D/g, '');
    const m = number2.match(/^(\d{3})(\d{3})(\d{4})$/);
    return `${!m ? number : `${m[1]}-${m[2]}-${m[3]}`}`;
  }
  return 'NA';
};

const formatCurrency = (currency) => {
  if (!isNaN(Number(currency))) {
    return `$${Number(currency).toLocaleString()}`;
  }
  return 'NA';
};


const formatCurrencyDash = (currency) => {
  if (currency.indexOf('$') > -1) {
    return currency;
  }
  if (currency && currency.toLowerCase().indexOf('over') > -1) {
    const newCurrency = currency.split(' ');
    return `${newCurrency[0]} $${newCurrency[1]}`;
  }
  if (!isNaN(Number(currency))) {
    return `$${Number(currency).toLocaleString()}`;
  } else if (currency.indexOf('-') > -1) {
    const actualCurrency = currency.split('-');
    return `$${actualCurrency[0]}-$${actualCurrency[1]}`;
  }
  return 'NA';
};

const formatAppDate = (appDate) => { // eslint-disable-line
  return moment(appDate, 'YYYY-MM-DD').format('MM/DD/YYYY') === 'Invalid date' ? 'NA' : moment(appDate, 'YYYY-MM-DD').format('MM/DD/YYYY');
};

const formatTenureInfo = (number) => {
  if (number !== null && number !== '99999') {
    return `${Math.floor(number / 12)} yrs ${number % 12} mo`;
  }
  return 'NA';
};

export const formatZip = (zip) => {
  const validData = (`${zip}`).replace(/\D/g, '');
  return `${!validData ? zip : `${validData.substr(0, 5)}-${validData.substr(5)}`}`;
};

const getFullName = (data) => {
  switch (data) {
    case 'E':
      return 'English';
    case 'S':
      return 'Spanish';
    default:
      return '';
  }
};

const getAssignmentSource = (value) => {
  switch (value) {
    case '1':
    case '2':
      return 'Manual Assign';
    case '3':
      return 'Auto Assign ';
    default:
      return '';
  }
};

const getCallType = (type, modelData, currentLanguage) => {
  let callType = '';
  let callTypeString = '';
  if (type && type !== undefined && type !== null) {
    let piclistValue = type;
    if (__CONFIG__.testManageApp) {
      piclistValue = piclistValue.toString();
    }
    callType = modelData.find(obj => piclistValue === obj.value.toString()).label;
    callTypeString = (currentLanguage === 'es' && callType === 'B') ? 'N' : callType;
  }
  return callTypeString;
};

const getInspectionCallType = (type, currentLanguage) => {
  let callType = '';
  let callTypeString = '';
  if (type && type !== undefined && type !== null) {
    callType = type === 3 ? 'B' : 'R';
    callTypeString = (currentLanguage === 'es' && callType === 'B') ? 'N' : callType;
  }
  return callTypeString;
};

const getCalltypeString = (calltype, language) => {
  if (calltype === 'Business' && language === 'es') {
    return 'Negocio';
  } else if (calltype === 'Residence' && language === 'es') {
    return 'Residencia';
  }
  return calltype;
};

const getFullCallType = (type, modelData, currentLanguage) => {
  let callType = '';
  if (type && type !== undefined && type !== null) {
    let piclistValue = type;
    if (__CONFIG__.testManageApp) {
      piclistValue = piclistValue.toString();
    }
    callType = modelData.find(obj => piclistValue === obj.value.toString()).label;
  }
  const fullCallType = {
    B: 'Business',
    R: 'Residence'
  };
  callType = fullCallType[callType] ? fullCallType[callType] : callType;
  return getCalltypeString(callType, currentLanguage);
};

const getLangIndicator = (type, modelData) => {
  let typeOfLang = '';
  if (type && type !== undefined && type !== null) {
    let piclistValue = type;
    if (__CONFIG__.testManageApp) {
      piclistValue = piclistValue.toString();
    }
    typeOfLang = modelData.find(obj => piclistValue === obj.value.toString()).label;
  }
  return getFullName(typeOfLang);
};

const getLeadType = (type, modelData) => {
  let typeOfLead = '';
  if (type && type !== undefined && type !== null) {
    let piclistValue = type;
    if (__CONFIG__.testManageApp) {
      piclistValue = piclistValue.toString();
    }
    typeOfLead = modelData.find(obj => piclistValue === obj.value.toString()).label;
  }
  return typeOfLead;
};

const getDisposition = (type, modelData, aptTime, sort) => {
  let typeOfDisposition = '';
  try {
    if (type !== undefined && type !== null) {
      let piclistValue = type;
      if (__CONFIG__.testManageApp) {
        piclistValue = piclistValue.toString();
      }
      try {
        typeOfDisposition = modelData.find(obj => piclistValue === obj.value.toString()).label;
      } catch (e) {
        console.log('Disposition Error==>', e);
      }
      if (!sort && aptTime && typeOfDisposition &&
        typeOfDisposition.indexOf('Appointment Set') !== -1) {
        typeOfDisposition = `Appointment ${aptTime}`;
      }
    }
  } catch (e) {
    console.log('Disposition Error1==>', e);
  }
  return typeOfDisposition;
};

const getExpireDays = (date, leadType, lastSellingAgent, ownerAgentCode, isOrphaned) => {
  let expires = '';
  const assignDate = moment.utc(date);
  if (leadType === 7 || leadType === '7') {
    expires = assignDate.add(366, 'days');
    const currentDate = moment.utc();
    if ((currentDate === 'Invalid Date') || (currentDate === undefined)) {
      return '';
    }
    // Calculate the difference in days
    const differenceMs = expires.diff(currentDate, 'days');
    return differenceMs;
  } else if (leadType === 3 || leadType === '3' || leadType === 6 || leadType === '6') {
    expires = assignDate.add(31, 'days');
    const currentDate = moment.utc();
    if ((currentDate === 'Invalid Date') || (currentDate === undefined)) {
      return '';
    }
    // Calculate the difference in days
    const differenceMs = expires.diff(currentDate, 'days');
    return differenceMs;
  } else if ((lastSellingAgent !== '' && lastSellingAgent !== ownerAgentCode) &&
    (leadType === 1 || leadType === '1' || leadType === 2 || leadType === '2') &&
    (isOrphaned !== 1 && isOrphaned !== '1' && isOrphaned !== true && isOrphaned !== 'true')) {
    console.log('LSA');
    expires = assignDate.add(31, 'days');
    const currentDate = moment.utc();
    if ((currentDate === 'Invalid Date') || (currentDate === undefined)) {
      return '';
    }
    // Calculate the difference in days
    const differenceMs = expires.diff(currentDate, 'days');
    return differenceMs;
  } else if (isOrphaned === 1 || isOrphaned === '1' || isOrphaned === true || isOrphaned === 'true') {
    expires = assignDate.add(61, 'days');
    const currentDate = moment.utc();
    if ((currentDate === 'Invalid Date') || (currentDate === undefined)) {
      return '';
    }
    // Calculate the difference in days
    const differenceMs = expires.diff(currentDate, 'days');
    return differenceMs.toString();
  }
};

const getAge = (date) => {
  const assignDate = moment.utc(date);
  const currentDate = moment.utc();
  // Calculate the difference in years
  const difference = currentDate.diff(assignDate, 'years');
  return difference;
};

const getCampaignExpireDays = (campaignDataRecords) => {
  let tempDateOne;
  const currentDate = new Date();
  tempDateOne = new Date(campaignDataRecords[0].cica_enddate);
  if (campaignDataRecords.length > 1) {
    campaignDataRecords.map((record) => {
      const tempDateTwo = new Date(record.cica_enddate);
      if (tempDateTwo >= tempDateOne) {
        tempDateOne = tempDateTwo;
      }
      return '';
    });
  }
  const endDate = tempDateOne;
  const expires = Math.round((endDate - currentDate) / (1000 * 60 * 60 * 24));
  return expires.toString(10);
};

const getInspectionExpireDays = (enddate) => {
  const assignDate = moment.utc(enddate);
  const expires = assignDate.add(21, 'days');
  const currentDate = moment.utc();
  // currentDate = currentDate.add(22, 'days');
  const differenceMs = expires.diff(currentDate, 'days');
  return differenceMs;
};

export const searchField = (searchValue, TableData, key) => {
  const Tablevalue = TableData.filter(
    obj => obj[key] && (obj[key].toLowerCase().indexOf(searchValue.toLowerCase()) > -1)
  );
  return Tablevalue;
};

export const searchFieldPhone = (searchValue, TableData, key, key2) => {
  const Tablevalue = TableData.filter(
    obj => (obj[key] && (obj[key].toLowerCase().indexOf(searchValue.toLowerCase()) > -1)) ||
    (obj[key2] && (obj[key2].toLowerCase().indexOf(searchValue.toLowerCase()) > -1))
  );
  return Tablevalue;
};

const getStatus = (data) => {
  if (data) {
    if (__CONFIG__.testManageApp) {
      return data.toString();
    }
    return data;
  }

  return '1';
};

const formatPhoneForDNC = (dncIndicator) => {
  if (dncIndicator) {
    return true;
  }
  return false;
};

const formatStreetNumber = (address, type) => {
  let returnValue;
  if (address !== null) {
    if (type === true) {
      returnValue = address.substr(0, address.indexOf(' '));
      return returnValue ? parseInt(returnValue, 10) : returnValue;
    }
    returnValue = address && address.substr(address.indexOf(' ') + 1);
    returnValue = returnValue.substr(0, returnValue.indexOf(' '));
    returnValue = returnValue.toUpperCase();
  }
  return returnValue;
};

const checkWarm = (leadType) => {
  if (leadType === 6 || leadType === '6') {
    return true;
  }
  return false;
};

const tabSelector = (element, ownerId) => {
  if ((element.ownerid === ownerId) && !(element.cica_selfassigned)) { // eslint-disable-line
    return 'Unassigned';
  }
  return 'Assigned';
};

const dobFormatter = (dob, leadType) => {
  let dobNew;
  if ((leadType === 7 || leadType === '7') && moment(dob, 'MM-DD-YYYY').format('DD-MM-YYYY') !== 'Invalid date') {
    dobNew = moment(dob, 'MM-DD-YYYY').format('DD-MM-YYYY') === 'Invalid date' ? 'NA' : moment(dob, 'MM-DD-YYYY').format('DD-MM-YYYY');
  } else {
    dobNew = moment(dob, 'YYYY-MM-DD').format('DD-MM-YYYY') === 'Invalid date' ? 'NA' : moment(dob, 'YYYY-MM-DD').format('DD-MM-YYYY');
  }

  if (dobNew !== 'NA') {
    dobNew = dobNew.split('-');
    dobNew = `${dobNew[1]}-XX-${dobNew[2]}`;
  }
  return dobNew;
};

const inspectiondobFormatter = (dob) => {
  let dobNew = moment(dob, 'YYYY-MM-DD').format('DD-MM-YYYY') === 'Invalid date' ? 'NA' : moment(dob, 'YYYY-MM-DD').format('DD-MM-YYYY');
  if (dobNew !== 'NA') {
    dobNew = dobNew.split('-');
    dobNew = `${dobNew[1]}-XX-${dobNew[2]}`;
  }
  return dobNew;
};

const getLastSellingAgentManager = (agentCode, agentsList, agentOrManager) => {
  const agentinList = agentsList.find(currentAgent => currentAgent.cica_agentcode === agentCode);
  if (agentinList) {
    const agentManager = agentsList.find(currentAgent => (currentAgent.cica_positioncode == 10 || currentAgent.cica_positioncode == 60 || currentAgent.cica_positioncode == 76) && //eslint-disable-line
      currentAgent.cica_territorycode === agentinList.cica_territorycode);
    if (agentOrManager === 'manager') {
      if (agentManager && agentManager.fullname) {
        const managerCode = agentManager.cica_agentcode;
        let agentManagerName = agentManager.fullname;
        agentManagerName = agentManagerName.split(' ');
        return `${agentManagerName[1]}, ${agentManagerName[0]} (${managerCode})`;
      }
      return '';
    }
    let agentName = agentinList.fullname;
    const agentsCode = agentinList.cica_agentcode;
    agentName = agentName.split(' ');
    return `${agentName[1]}, ${agentName[0]} (${agentsCode})`;
  }
  return '';
};

const showOrphan = (isOrphan) => {
  if (isOrphan === false) {
    return 'Active Only';
  }
  return 'Orphan Only';
};

export const formatDataForTableView = (List, optionSets, ownerid, ownerGuid, priAndSecRecordMapping,
  campaignRecords, inspData, agentData) => {
    if (__MANAGE__) {
      console.log('List==>', List);
      manageList = List.data;
      picklistdata = List.picklistdata;
      const ownerAgentCode = List.agentCode;
      const appointmentData = List.appointmentTimeValues;
      const primaryAndSecondaryRecordMapping = {};
      let manageListFormatted = [];
      manageList.forEach((element) => {
        let campaignDataRecords = campaignManageData.filter(recordObj =>
          element.cica_personid && recordObj.cica_name &&
          element.cica_personid.indexOf(recordObj.cica_name) > -1);
        let ropRecords = campaignDataRecords
        .filter(
          obj => obj.cica_isrop &&
              obj.cica_isrop === 'true'
        );
        const nonROPRecords = campaignDataRecords
        .filter(
          obj => !(obj.cica_isrop &&
                      obj.cica_isrop === 'true')
        );
        ropRecords = _.sortBy(ropRecords, value => new Date(value.createdon))
        .reverse()
        .slice(0, 5);
        campaignDataRecords = [...ropRecords, ...nonROPRecords];
        const expiryDate = ((campaignDataRecords.length > 0) && (element.cica_leadtype === '5' || element.cica_leadtype === 5)) ?
            getCampaignExpireDays(campaignDataRecords) :
            getExpireDays(element.cica_assigneddate, element.cica_leadtype, element.cica_lastsellingagent, ownerAgentCode, element.cica_isorphaned);
        const exipryDateCheck =  (expiryDate !== '' && expiryDate !== undefined) ? expiryDate.toString() : 'NA';
        if (expiryDate < 0) {
          return;
        }
       
        const wholeAptData = appointmentData ? appointmentData.leadsAppointmentTime : '';
        let aptTime = '';
        const elementId = element.id;
        if (wholeAptData) {
          aptTime = wholeAptData.find(obj => elementId.indexOf(obj.leadId) !== -1); // eslint-disable-line
        }
        const leadAptTime = (element.appointmentdate !== null && element.appointmentdate !== '') ? moment.utc(element.appointmentdate).format('MM/DD hh:mma') : 'NA';
        const leadType = getLeadType(element.cica_leadtype, picklistdata.cicaLeadTypeModel);
        const nullCheckForPcname = element.cica_pcname === 'null' || element.cica_pcname === '' || element.cica_pcname === null || element.cica_pcname === undefined;
        const record = {
          name: `${toTitleCase(element.lastname)}`,
          quickbarName: (leadType === 'Warm') ? (nullCheckForPcname ? `${toTitleCase(element.lastname)}` : `${toTitleCase(element.cica_pcname)}`) : `${toTitleCase(element.lastname)}`, // eslint-disable-line
          state: element.cica_pcstate,
          county: toTitleCase(element.cica_pccounty),
          city: toTitleCase(element.cica_pccity),
          primaryContact: nullCheckForPcname ? 'NA' : `${toTitleCase(element.cica_pcname)}`,
          callType: getCallType(element.cica_calltype, picklistdata.cicaCallTypeModel,
            List.currentLanguage),
          fullCallType: getFullCallType(element.cica_calltype, picklistdata.cicaCallTypeModel,
            List.currentLanguage),
          email: element.emailaddress1,
          isappointmentterminated: element.isappointmentterminated,
          appointmentdate: (element.appointmentdate !== null && element.appointmentdate !== '') ? moment.utc(element.appointmentdate).format('YYYY-MM-DD hh:mma') : 'NA', 
          leadType,
          campaignLeadType: element.cica_campaignleadtype,
          phone: formatPhoneForDNC(element.cica_dncindicator) ? 'DNC' : formatPhoneNumber(element.mobilephone),
          zip: formatZip(element.cica_pczip),
          disposition: element.cica_leaddispositionstatus ? getDisposition(element.cica_leaddispositionstatus, picklistdata.cicaLeadDispositionStatusModel, leadAptTime, false) : 'Unworked',
          status: getStatus(element.cica_leaddispositionstatus),
          tier: element.tier && element.tier !== 0.0 && element.tier !== '0.0' ? Math.ceil(element.tier).toString() : 'NA', // eslint-disable-line
          expires: exipryDateCheck,
          id: element.id,
          doNotCallAfter: moment(element.cica_dncafterdate).format('MM-DD-YYYY') === 'Invalid date' ? 'NA' : moment(element.cica_dncafterdate).format('MM-DD-YYYY'),
          language: getLangIndicator(
            element.cica_langindicator, picklistdata.cicaLangIndicatorModel
          ),
          lastSellingAgent: toTitleCase(element.cica_lastsellingagentname),
          leadsDescription: element.description,
          businessAddress: `${element.address2_line1 ? `${element.address2_line1}, ${toTitleCase(element.address2_city)}` : 'NA'}`,
          residentialAddress: `${element.cica_pcstreet ? `${element.cica_pcstreet}` : 'NA'}`,
          residentialAddressCarousel: `${element.address1_line1 ? `${element.address1_line1}, ${toTitleCase(element.address1_city)}` : ''}`,
          residentialPhoneCarousel: formatPhoneForDNC(element.cica_dncindicator) ? 'DNC' : element.address1_telephone1,
          alternatePhoneCarousel: formatPhoneForDNC(element.cica_dncindicator) ? 'DNC' : element.address1_telephone2,
          businessPhoneCarousel: formatPhoneForDNC(element.cica_dncindicator) ? 'DNC' : element.address2_telephone1,
          residentialPhone: formatPhoneForDNC(element.cica_dncindicator) ? 'DNC' : element.mobilephone,
          alternatePhone: formatPhoneForDNC(element.cica_dncindicator) ? 'DNC' : element.address1_telephone1,
          householdIndicator: element.cica_householdkeycode,
          businessPhone: formatPhoneForDNC(element.cica_dncindicator) ? 'DNC' : element.address2_telephone1,
          tenure: formatTenureInfo(element.cica_yrsmonthsph),
          insuredDOB: dobFormatter(element.cica_dob, element.cica_leadtype),
          age: element.cica_age,
          firm: element.companyname,
          occupation: element.cica_occupation,
          campaign: campaignDataRecords && campaignDataRecords.length > 0 ?
            campaignDataRecords.map(records => toTitleCase(records.cica_campaign)) : null,
          campaignPurpose: campaignDataRecords && campaignDataRecords.length > 0 ?
          campaignDataRecords.map(records => toTitleCase(records.cica_purpose)) : null,
          isSecondary: Boolean(element.cica_householdkeycode),
          showHouseKey: element.cica_householdkeycode ? null : 1,
          personId: element.cica_personid,
          yearsInBusiness: element.cica_yearsofbusiness,
          industry: checkWarm(element.cica_leadtype) ? 'NA' : element.description,
          numberofemployee: element.numberofemployees,
          homeBusiness: element.cica_homebase,
          lastAssignedAgent: element.cica_lastassignedagent,
          notes: element.cica_comments,
          lastDispositionDate: moment(element.cica_lastdispositiondate).format('MM-DD-YYYY') === 'Invalid date' ? 'NA' : moment(element.cica_lastdispositiondate).format('MM-DD-YYYY'),
          lastDispositionState: element.cica_lastdispositionstate ? getDisposition(element.cica_lastdispositionstate, picklistdata.cicaLeadDispositionStatusModel) : 'NA',
          assignedDate: element.cica_assigneddate,
          cica_comments: element.cica_comments,
          cica_notes: element.cica_notes,
          cbe: element.cica_cbe,
          cbeproduct1: element.cica_cbeproduct1,
          cbeproduct2: element.cica_cbeproduct2,
          cbeproduct3: element.cica_cbeproduct3,
          cbeproduct4: element.cica_cbeproduct4,
          isPersonal: (element.cica_leadtype === 7 || element.cica_leadtype === '7'),
          streetNumber: formatStreetNumber(element.cica_pcstreet, true),
          streetName: formatStreetNumber(element.cica_pcstreet, false),
          appointmentTime: leadAptTime,
          isOrphaned: element.cica_isorphaned,
          lastSellingAgentCode: element.cica_lastsellingagent,
          dispositionSort: element.cica_leaddispositionstatus ? getDisposition(element.cica_leaddispositionstatus, picklistdata.cicaLeadDispositionStatusModel, leadAptTime, true) : 'Unworked',
          appointmentDisp: 'Appointment Set'
        };
        manageListFormatted.push(record);
        if (primaryAndSecondaryRecordMapping[element.cica_householdkeycode]) {
          primaryAndSecondaryRecordMapping[element.cica_householdkeycode].push(record);
        } else if (element.cica_householdkeycode) {
          primaryAndSecondaryRecordMapping[element.cica_householdkeycode] = [record];
        }
      });
      manageListFormatted = manageListFormatted.map((rec) => {
        const record = rec;
        Object.keys(primaryAndSecondaryRecordMapping).forEach((key) => {
          if (key && key !== null && record.personId === key) {
            primaryAndSecondaryRecordMapping[key].forEach((data) => {
              if (data.campaign !== null) {
                if (_.isArray(record.campaign)) {
                  record.campaign = [...record.campaign, ...data.campaign];
                } else {
                  record.campaign = data.campaign;
                }
              }
              if (Math.abs(data.expires) > Math.abs(record.expires)) {
                record.expires = data.expires;
              }
            });
          }
        });
        return record;
      });
      const wholeData = {
        manageList: manageListFormatted,
        picklistdata,
        primaryAndSecondaryRecordMapping,
        currentLanguage: List.currentLanguage
      };
      return wholeData;
    }
  else {
    console.log('Assigner');
  const transformedList = {
    data: [],
    primaryAndSecondaryRecordMapping: _.cloneDeep(priAndSecRecordMapping)
  };
  List.forEach((element) => {
    const CampaignData = campaignRecords && campaignRecords.filter(obj =>
      element.cica_personid && element.cica_personid.indexOf(obj.cica_name) > -1
    );
    const nullCheckForPcname = element.cica_pcname === 'null' || element.cica_pcname === '' || element.cica_pcname === null || element.cica_pcname === undefined;
    const record = {
      name: `${toTitleCase(element.lastname)}`,
      state: element.cica_pcstate,
      county: toTitleCase(element.cica_pccounty),
      city: toTitleCase(element.cica_pccity),
      zip: formatZip(element.cica_pczip),
      leadType: optionSets && optionSets.leadType &&
        optionSets.leadType.find(obj => obj.value === element.cica_leadtype) &&
        optionSets.leadType.find(obj => obj.value === element.cica_leadtype).label,
      language: getFullName(element.cica_langindicator ?
        optionSets.languageIndicator.find(obj => obj.value === element.cica_langindicator).label : ''),
      disposition: element.cica_leaddispositionstatus ?
        optionSets.disposition.find(
          obj => obj.value === element.cica_leaddispositionstatus
        ).label : 'Unworked',
      lastAssigned: toTitleCase(element.cica_lastassignedagent),
      notes: 'NA',
      assignmentSource: element.cica_leadassignmentsource ? getAssignmentSource(element.cica_leadassignmentsource) : '', // eslint-disable-line
      tier: element.Tier && element.Tier !== 0.0 && element.Tier !== '0.0' ? Math.ceil(element.Tier).toString() : 'NA', // eslint-disable-line
      isappointmentterminated: element.isappointmentterminated,
      appointmentdate: (element.appointmentdate !== null && element.appointmentdate !== '') ? moment.utc(element.appointmentdate).format('YYYY-MM-DD hh:mma') : 'NA',
      assignedDate: element.cica_assigneddate ? moment(element.cica_assigneddate).format('MM/YY') : undefined,
      lastSelling: toTitleCase(element.cica_lastsellingagentname),
      lastassignedagentCode: element.cica_lastsellingagent,
      isOrphaned: showOrphan(element.cica_isorphaned),
      lineOneManager: getLastSellingAgentManager(element.cica_lastsellingagent, agentData, 'manager'), // eslint-disable-line
      activeLastSellingAgentName: getLastSellingAgentManager(
        element.cica_lastsellingagent, agentData),
      assignedTo: toTitleCase(element.cica_assignedagentid),
      householdIndicator: element.cica_householdkeycode,
      status: tabSelector(element, ownerGuid),
      id: element.leadid,
      lastDispositionDate: element.cica_lastdispositiondate,
      lastDispositionState: element.cica_leaddispositionstatus,
      ownerid: element.ownerid, // eslint-disable-line
      campaign: CampaignData && CampaignData.length > 0 ?
        CampaignData.map(records => toTitleCase(records.cica_campaign)) : null,
      campaignPurpose: CampaignData && CampaignData.length > 0 ?
        CampaignData.map(records => toTitleCase(records.cica_purpose)) : null,
      personId: element.cica_personid,
      isSecondary: Boolean(element.cica_householdkeycode),
      showHouseKey: element.cica_householdkeycode ? null : 1,
      selfAssigned: element.cica_selfassigned,
      streetAddress: toTitleCase(element.cica_pcstreet),
      description: element.description || 'NA',
      primaryContact: nullCheckForPcname ? 'NA' : `${toTitleCase(element.cica_pcname)}`,
      residentialPhone: formatPhoneForDNC(element.cica_dncindicator) ? 'DNC' : element.mobilephone,
      insuredDOB: dobFormatter(element.cica_dob, element.cica_leadtype),
      fullCallType: optionSets && optionSets.leadType &&
      optionSets.callType.find(obj => obj.value === element.cica_calltype) &&
      optionSets.callType.find(obj => obj.value === element.cica_calltype).label,
      residentialAddress: toTitleCase(element.cica_pcstreet),
      alternatePhoneCarousel: formatPhoneForDNC(element.cica_dncindicator) ? 'DNC' : element.address1_telephone2,
      businessPhoneCarousel: formatPhoneForDNC(element.cica_dncindicator) ? 'DNC' : element.address2_telephone1,
      age: element.cica_age,
      email: element.emailaddress1,
      doNotCallAfter: moment(element.cica_dncafterdate).format('MM-DD-YYYY') === 'Invalid date' ? 'NA' : moment(element.cica_dncafterdate).format('MM-DD-YYYY'),
      tenure: formatTenureInfo(element.cica_yrsmonthsph),
      firm: element.companyname,
      homeBusiness: element.cica_homebase,
      occupation: element.cica_occupation,
      yearsInBusiness: element.cica_yearsofbusiness,
      industry: checkWarm(element.cica_leadtype) ? 'NA' : element.description,
      numberofemployee: element.numberofemployees,
      lastAssignedAgent: element.cica_lastassignedagent,
      dateAssignedValue: element.cica_assigneddate ? moment(element.cica_assigneddate).format('MM/YY') : undefined,
      lastSellingAgent: toTitleCase(element.cica_lastsellingagentname),
      newPolicy: element.cica_isnewpolicy ? 'Yes': 'No',
      isNeeedToContactBeforeVisit: element.cica_isneedstobecontactedbeforevisit ? 'Yes' : 'No',
      companySize: element.cica_companysize ? element.cica_companysize : 'NA',
      jobTitle: element.cica_jobtitle ? element.cica_jobtitle: 'NA',
      bestWayToContactBefore: element.cica_bestwaytocontactbf ? element.cica_bestwaytocontactbf : 'NA'
    };
    transformedList.data.push(record);
    if (transformedList && transformedList.primaryAndSecondaryRecordMapping &&
      transformedList.primaryAndSecondaryRecordMapping[element.cica_householdkeycode]) {
      transformedList.primaryAndSecondaryRecordMapping[element.cica_householdkeycode]
      .push(record);
    } else if (element.cica_householdkeycode) {
      transformedList.primaryAndSecondaryRecordMapping[element.cica_householdkeycode] = [record];
    }
  });
    return transformedList;
  }
};

const getFormattedAddress = (element, type) => {
  let returnAddress = '';
  if (type === 'business') {
    returnAddress = element.cica_businessaddress ? `${element.cica_businessaddress}<p>` : '';
    returnAddress += element.cica_businessaddresscity && element.cica_businessaddresscity !== 'NA' ? `${element.cica_businessaddresscity}` : '';
    returnAddress += element.cica_businessaddressstate && element.cica_businessaddressstate !== 'NA' ? ` ${element.cica_businessaddressstate}` : '';
    returnAddress += element.cica_businessaddresszip && element.cica_businessaddresszip !== 'NA' ? ` ${element.cica_businessaddresszip}` : '';
  } else if (type === 'residential') {
    returnAddress = element.cica_residentialaddress ? `${element.cica_residentialaddress}<p>` : '';
    returnAddress += element.cica_residentialaddresscity && element.cica_residentialaddresscity !== 'NA' ? `${element.cica_residentialaddresscity}` : '';
    returnAddress += element.cica_residentialaddressstate && element.cica_residentialaddressstate !== 'NA' ? ` ${element.cica_residentialaddressstate}` : '';
    returnAddress += element.cica_residentialaddresszip && element.cica_residentialaddresszip !== 'NA' ? ` ${element.cica_residentialaddresszip}` : '';
  }
  return returnAddress;
};

const getProductShortForm = (name) => {
  switch (name) {
    case '1':
      return 'AP';
    case '2':
      return 'ASP';
    case '3':
      return 'OPM';
    case '4':
      return 'CAN';
    case '5':
      return 'CP';
    case '6':
      return 'CRT';
    case '7':
      return 'FLP';
    case '8':
      return 'GAP';
    case '9':
      return 'SPJ';
    case '10':
      return 'IP';
    case '11':
      return 'SPP';
    case '12':
      return 'SP';
    case '13':
      return 'LTL';
    default :
      return '';
  }
};

const getPaymentType = (name) => {
  switch (name) {
    case '320580000':
      return 'Checking';
    case '320580001':
      return 'Credit or Debit';
    case '320580002':
      return 'Savings account';
    default :
      return '';
  }
};

const truncateString = (string) => {
  if (string !== 'NA') {
    if (string.length > 78) {
      return `${string.substring(0, 77)}...`;
    }
    return string;
  }
  return 'NA';
};

export const ordinalSuffixOf = (i) => {
  const j = i % 10;
  const k = i % 100;
  if (j === 1 && k !== 11) {
    return `${i}st`;
  }
  if (j === 2 && k !== 12) {
    return `${i}nd`;
  }
  if (j === 3 && k !== 13) {
    return `${i}rd`;
  }
  return `${i}th`;
};

export const formatInspDataForTableView = (list) => {
  const insFormattedData = [];
  list.forEach((element) => {
    const record = {
      cica_customername: truncateString(`${element.cica_customerlastname ?
        element.cica_customerlastname : ''}, ${element.cica_customername ?
          element.cica_customername : ''}`),
      cica_writingagent: truncateString(`${element.cica_writingagentlastname ?
        element.cica_writingagentlastname : ''}, ${element.cica_writingagent ?
          element.cica_writingagent : ''}`),
      cica_primarycontact: truncateString(`${element.cica_primarycontactlastname ?
        element.cica_primarycontactlastname : ''}, ${element.cica_primarycontact ?
          element.cica_primarycontact : ''}`),
      cica_writingagentsmanager: truncateString(`${element.cica_writingagentsmanagerlastname ?
        element.cica_writingagentsmanagerlastname : ''}, ${element.cica_writingagentsmanager ?
          element.cica_writingagentsmanager : ''}`),
      id: element.cica_inspectionsid,
      cica_calltype: getInspectionCallType(element.cica_calltype, list.currentLanguage),
      phoneNumber: element.cica_calltype === 3 ? formatPhoneNumber(element.cica_businessphone) :
        formatPhoneNumber(element.cica_residentialphone),
      division: `${element.cica_division}-${element.cica_mrkt}`,
      product: element.cica_productcode ? getProductShortForm(element.cica_productcode) : 'NA',
      cica_appdate: element.cica_appdate ? formatAppDate(element.cica_appdate) : '',
      expires: element.createdon ? `${getInspectionExpireDays(element.createdon)} Days` : 'NA',
      cica_fdif: moment(element.cica_fdif, 'YYYY-MM-DD').format('MM/DD/YYYY'),
      cica_residentialphone: element.cica_residentialphone ? formatPhoneNumber(element.cica_residentialphone) : 'NA',
      cica_insuredsdob: inspectiondobFormatter(element.cica_insuredsdob),
      cica_residentialaddress: getFormattedAddress(element, 'residential'),
      cica_alternatephone: element.cica_alternatephone ? formatPhoneNumber(element.cica_alternatephone) : '',
      // cica_age: element.cica_age ? element.cica_age : 'NA',
      cica_age: element.cica_insuredsdob ? getAge(element.cica_insuredsdob) : 'NA',
      cica_languagepreference: (element.cica_languagepreference === 1 || element.cica_languagepreference === '1') ? 'English' : 'Spanish',
      cica_writingagentcode: element.cica_writingagentcode,
      cica_businessname: element.cica_businessname ? truncateString(`${element.cica_businessname}`) : 'NA',
      cica_businessphone: element.cica_businessphone ? formatPhoneNumber(element.cica_businessphone) : 'NA',
      cica_businessaddress: getFormattedAddress(element, 'business'),
      cica_occupation: element.cica_occupation,
      cica_initialpaymenttype: getPaymentType(element.cica_initialpaymenttype),
      cica_recurringpaymenttype: getPaymentType(element.cica_recurringpaymenttype),
      cica_policytype: element.cica_policytype ? element.cica_policytype : 'NA',
      cica_grossannualhouseholdincome: element.cica_grossannualhouseholdincome ? formatCurrencyDash(element.cica_grossannualhouseholdincome) : 'NA',
      cica_apv: element.cica_apv ? formatCurrency(element.cica_apv) : 'NA',
      cica_monthlypremiuim: (element.cica_monthlypremium && (element.cica_premiummode === 320580000 || element.cica_premiummode === '320580000')) ? formatCurrency(element.cica_monthlypremium) : 'NA',
      cica_grossindividualannualincome: element.cica_grossindividualannualincome ? element.cica_grossindividualannualincome : 'NA',
      cica_premiummode: (element.cica_premiummode === 320580000 || element.cica_premiummode === '320580000') ? 'Monthly' : 'Annually',
      cica_premiumbillingdate: element.cica_premiumbillingdate ? ordinalSuffixOf(element.cica_premiumbillingdate) : 'NA',
      cica_issubmitted: element.cica_issubmitted || false,
      cica_isexpired: getInspectionExpireDays(element.createdon) < 0,
      cica_customerFirstLastname: `${element.cica_customername ?
        element.cica_customername : ''} ${element.cica_customerlastname ?
          element.cica_customerlastname : ''}`,
      cica_writingagentFirstLastName: `${element.cica_writingagent ?
        element.cica_writingagent : ''} ${element.cica_writingagentlastname ?
          element.cica_writingagentlastname : ''}`,
      cica_writingagentsmanagerFirstLastName: `${element.cica_writingagentsmanager ?
        element.cica_writingagentsmanager : ''} ${element.cica_writingagentsmanagerlastname ?
          element.cica_writingagentsmanagerlastname : ''}`,
    };
    insFormattedData.push(record);
  });
  return insFormattedData;
};

export const fetchLeadData = (stateSelected, citySelected, zipSelected) => {
  const dataPayload = {
    modelName: 'cicaLeadsModel',
    picklistArray: ['cicaLeadDispositionStatusModel', 'cicaCallTypeModel', 'cicaRopBillingModel', 'cicaLangIndicatorModel', 'cicaLeadTypeModel', 'cicaDncIndicatorModel', 'cicaReasonCodeModel', 'cicaPhonenumberTypeModel', 'cicaLangIndicatorModel'],
    query: 'Select * from lead where ((cica_isactive = "1" OR cica_isactive = "null" OR cica_isactive = "true") and cica_leadtype = 7 and cica_assigneddate BETWEEN datetime("now","-364 days") AND datetime("now", "+1 days")) OR  (cica_leadtype != 7 and cica_leadtype != 5) OR cica_leadtype = 5',
    queryTM: 'Select * from lead where ((cica_isactive = "1" OR cica_isactive = "null" OR cica_isactive = "true") and cica_leadtype = 7 and (cica_selfassigned = "true" OR cica_selfassigned = "1") and cica_assigneddate BETWEEN datetime("now","-364 days") AND datetime("now", "+1 days")) OR  (cica_leadtype != 7 and cica_leadtype != 5 and (cica_selfassigned = "true" OR cica_selfassigned = "1")) OR (cica_leadtype = 5 and (cica_selfassigned = "true" OR cica_selfassigned = "1"))',
    queryOP: 'Select * from lead',
    stateSelect: stateSelected,
    citySelect: citySelected,
    zipSelect: zipSelected
  };
  return new Promise((resolve, reject) => {
    handleAppEvent('FETCH_LEAD_DATA', dataPayload).then((successData) => {
      if (successData.data.length > 0) {
        try {
          resolve(formatDataForTableView(successData));
        } catch (e) {
          console.log('error', e);
        }
      } else {
        const wholeData = {
          manageList: [],
          picklistdata: [],
          primaryAndSecondaryRecordMapping: [],
          currentLanguage: successData.currentLanguage
        };
        resolve(wholeData);
        // reject('Error Retreiving Values from DB');
      }
    }, () => {
      reject('Error Retreiving Values from DB');
    });
  });
};

export const fetchOpenLeadSearchData = () => {
  const dataPayload = {
    modelName: 'cicaMiscellaneousModel',
    query: 'Select * from cica_miscellaneous',
    picklistArray: ['cicaLeadDispositionStatusModel', 'cicaCallTypeModel', 'cicaRopBillingModel', 'cicaLangIndicatorModel', 'cicaLeadTypeModel', 'cicaDncIndicatorModel', 'cicaReasonCodeModel', 'cicaPhonenumberTypeModel', 'cicaLangIndicatorModel']
  };
  return new Promise((resolve, reject) => {
    handleAppEvent('FETCH_OPEN_SEARCH_LEAD_DATA', dataPayload).then((successData) => {
      if (successData.data.length > 0) {
        try {
          resolve(formatDataForTableView(successData));
        } catch (e) {
          console.log('error', e);
        }
      } else {
        const wholeData = {
          manageList: [],
          picklistdata: [],
          primaryAndSecondaryRecordMapping: [],
          currentLanguage: successData.currentLanguage
        };
        resolve(wholeData);
        // reject('Error Retreiving Values from DB');
      }
    }, () => {
      reject('Error Retreiving Values from DB in handle');
    });
  });
};

export const fetchManageCampaignData = () => {
  const dataPayload = {
    modelName: 'cicaCampaignLeadsModel',
    query: 'Select * from cica_campaignleads WHERE (cica_isactive = "1" OR cica_isactive = "null" OR cica_isactive = "true" OR cica_isactive IS NULL)'
  };

  return new Promise((resolve, reject) => {
    handleAppEvent('FETCH_MANAGE_CAMPAIGN_DATA', dataPayload).then((successData) => {
      campaignManageData = successData;
      resolve(campaignManageData);
    }, () => {
      reject('Error Retreiving Values from DB');
    });
  });
};

export const fetchUserLicense = () => {
  console.log('Fetching License');
  const dataPayload = {
    modelName: 'cicaLicenseModel'
  };
  return new Promise((resolve, reject) => {
    handleAppEvent('FETCH_MANAGE_LICENSE', dataPayload).then((successData) => {
      console.log('successData License', successData);
      resolve(successData);
    }, () => {
      reject('Error Retreiving Values from DB');
    });
  });
};

export const getOpenLeads = (stateSelected) => {
  console.log('Getting Open Leads');
  const dataPayload = {
    modelName: 'cicaLeadsModel',
    statesSelected: stateSelected
  };
  return new Promise((resolve, reject) => {
    handleAppEvent('FETCH_OPEN_LEADS', dataPayload).then((successData) => {
      console.log('successData Open Leads', successData);
      resolve(successData);
    }, () => {
      reject('Error Retreiving Values from DB');
    });
  });
};

export const fetchDraftsData = () => {
  const dataPayload = {
    modelName: 'draftsModel',
    query: 'SELECT * FROM cica_drafts WHERE status = "RECEIVED"',
    picklistArray: []
  };
  return new Promise((resolve, reject) => {
    handleAppEvent('FETCH_DATA', dataPayload).then((successData) => {
      if (successData.data.length > 0) {
        resolve(successData);
      } else {
        reject('No Data in Drafts');
      }
    }, () => {
      reject('Error Retreiving Values from DB');
    });
  });
};
export const fetchContactData = (id) => {
  if (__MANAGE__ && !__CONFIG__.testManageApp) {
    const dataPayload = {
      modelName: 'cicaLeadsModel',
      query: `Select * from lead where id="${id}"`
    };
    return new Promise((resolve, reject) => {
      handleAppEvent('FETCH_CONTACT_DATA', dataPayload).then((successData) => {
        if (successData.length > 0) {
          resolve(successData[0]);
        } else {
          reject('No such record in DB');
        }
      }, () => {
        reject('Error Retreiving Values from DB');
      });
    });
  }
  return new Promise((resolve, reject) => {
    const data = manageList;
    if (data.length > 0) {
      const selectedItem = data.find(current => current.id === id);
      if (selectedItem) {
        resolve(selectedItem);
      } else {
        reject('Error Retreiving Values from Data file');
      }
    } else {
      reject('Error Retreiving Values from DB');
    }
  });
};

export const insertContactData = (insertData) => {
  if (__MANAGE__ && !__CONFIG__.testManageApp) {
    const dataPayload = {
      modelName: 'cicaLeadsModel',
      data: {
        record: insertData
      }
    };
    return new Promise((resolve, reject) => {
      handleAppEvent('INSERT_DATA', dataPayload).then((successData) => {
        if (successData) {
          resolve(successData);
        } else {
          reject('No such record in DB');
        }
      }, () => {
        reject('Error Retreiving Values from DB');
      });
    });
  }
  return new Promise((resolve) => {
    resolve('success');
  });
};

export const fetchPolicyData = (id) => {
  const dataPayload = {
    modelName: 'cicaPolicyInformationModel',
    query: `Select * from cica_policyinformation where cica_personid="${id}"`,
    picklistArray: ['cicaPolicyInfoTypeModel']
  };
  return new Promise((resolve, reject) => {
    handleAppEvent('FETCH_DATA', dataPayload).then((successData) => {
      if (successData.data.length > 0) {
        resolve(successData);
      } else {
        reject('No such record in DB');
      }
    }, () => {
      reject('Error Retreiving Values from DB');
    });
  });
};

export const updateContactData = (data) => {
  if (__MANAGE__ && !__CONFIG__.testManageApp) {
    const dataPayload = {
      modelName: 'cicaLeadsModel',
      updateData: data
    };
    return new Promise((resolve, reject) => {
      handleAppEvent('UPDATE_DATA', dataPayload).then((successData) => {
        if (successData !== undefined) {
          resolve(successData);
        } else {
          reject('No such record in DB');
        }
      }, () => {
        reject('Error Retreiving Values from DB');
      });
    });
  }
  return new Promise((resolve) => {
    resolve('success');
  });
};

export const updateToMiscData = (data) => {
  if (__MANAGE__ && !__CONFIG__.testManageApp) {
    const dataPayload = {
      leadApmtData: data
    };
    return new Promise((resolve, reject) => {
      handleAppEvent('UPDATE_MISC', dataPayload).then((successData) => {
        if (successData !== undefined) {
          resolve(successData);
        } else {
          reject('No such record in DB');
        }
      }, () => {
        reject('Error Retreiving Values from DB');
      });
    });
  }
  return new Promise((resolve) => {
    resolve('success');
  });
};

export const deletePersonalLeadData = (id) => {
  if (__MANAGE__ && !__CONFIG__.testManageApp) {
    const dataPayload = {
      modelName: 'cicaLeadsModel',
      data: {
        record: id
      }
    };
    return new Promise((resolve, reject) => {
      handleAppEvent('DELETE_PERSONAL_LEAD_DATA', dataPayload).then((successData) => {
        if (successData !== undefined) {
          resolve(successData);
        } else {
          reject('No such record in DB');
        }
      }, () => {
        reject('Error Retreiving Values from DB');
      });
    });
  }
  return new Promise((resolve) => {
    resolve('success');
  });
};

export const orderBy = (list, key, direction, SortDirection) => {
  if (list.length <= 0) {
    return list;
  }
  if (key === 'residentialAddress') {
    if (direction === SortDirection.DESC) {
      return _.orderBy(list, ['streetName', 'streetNumber', 'name'], ['desc', 'asc', 'asc']);
    }
    return _.orderBy(list, ['streetName', 'streetNumber', 'name'], ['asc', 'asc', 'asc']);
  }
  if (key === 'disposition') {
    if (direction === SortDirection.DESC) {
      return _.orderBy(list, ['dispositionSort', 'appointmentTime', 'name'], ['desc', 'desc', 'asc']);
    }
    return _.orderBy(list, ['dispositionSort', 'appointmentTime', 'name'], ['asc', 'asc', 'asc']);
  }
  if(key === 'assignedDate') {  // Added as part of SR 1371
   list.sort((a, b) => {
    if ((a.assignedDate !== null && a.assignedDate !== undefined) && (b.assignedDate !== null && b.assignedDate !== undefined)) {
      const c = a.assignedDate.split('/').reverse().join();
      const d = b.assignedDate.split('/').reverse().join();
      if(direction === SortDirection.ASC) {
        return c && d && (c < d) ? -1 : c > d ? 1 : 0;
      }
      return c && d && (c > d) ? -1 : c < d ? 1 : 0;
    }
   })
   return list;
  } 
  if(key === 'dateAssignedValue') {  // Added as part of SR 1371
    list.sort((a, b) => {
     if ((a.dateAssignedValue !== null && a.dateAssignedValue !== undefined) && (b.dateAssignedValue !== null && b.dateAssignedValue !== undefined)) {
       const c = a.dateAssignedValue.split('/').reverse().join();
       const d = b.dateAssignedValue.split('/').reverse().join();
       if(direction === SortDirection.ASC) {
         return c && d && (c < d) ? -1 : c > d ? 1 : 0;
       }
       return c && d && (c > d) ? -1 : c < d ? 1 : 0;
    }
     })
    return list;
   } 
  if (direction === SortDirection.DESC) {
    return _.orderBy(list, [key, 'name'], ['desc', 'asc']);
  }

  return _.orderBy(list, [key, 'name'], ['asc', 'asc']);
};

export const orderByInspections = (list, key, direction, SortDirection) => {
  if (list.length <= 0) {
    return list;
  }
  const newList = list.map((item) => {
    const expireDate = item.expires.split(' ');
    item.formattedExpireDate = _.toNumber(expireDate[0]); // eslint-disable-line
    return item;
  });
  const sortKey = (key === 'expires') ? 'formattedExpireDate' : key;
  let sortedList = [];
  if (direction === SortDirection.DESC) {
    sortedList = _.orderBy(newList, [sortKey, 'formattedExpireDate', 'cica_writingagent', 'cica_customername'], ['desc', 'asc', 'asc', 'asc']);
    return sortedList;
  }
  sortedList = _.orderBy(newList, [sortKey, 'formattedExpireDate', 'cica_writingagent', 'cica_customername'], ['asc', 'asc', 'asc', 'asc']);
  return sortedList;
};

export const contains = (list, element, predicate) => {
  const predicateFunc = (!predicate) ? (obj, index) => index : predicate;
  const index = list.findIndex(predicateFunc);
  if (index > -1) {
    return true;
  }

  return false;
};

export const inspectionFilterCRMFieldMap = (field = null, receivedString) => {
  let string = _.clone(receivedString);
  if (_.isEmpty(string)) {
    string = {};
  }
  const inspectionFilterMap = [
    {
      label: string.writingagent,
      type: 'cica_writingagent',
      options: 'writingAgent',
      tab: 'single',
      hintText: string.writingagent
    },
    {
      label: string.product,
      type: 'product',
      options: 'product',
      tab: 'single',
      hintText: string.product
    },
    {
      label: string.division,
      type: 'division',
      options: 'division',
      tab: 'single',
      hintText: string.division
    },
    {
      label: string.dateofapp,
      type: 'cica_appdate',
      options: 'appDate',
      tab: 'single',
      hintText: string.appdate
    },
  ];

  if (field) {
    return _.find(inspectionFilterMap, ['options', field]).type;
  }
  return inspectionFilterMap;
};

export const searchPopUpFilterMap = (field = null, receivedString) => {
  let string = _.clone(receivedString);
  if (_.isEmpty(string)) {
    string = {};
  }
  const searchPopUpMap = [
    {
      label: string.stateOpen,
      hintText: string.state,
      type: "State",
      options: "licensedStatesValue"
    },
    {
      label: string.cityOpen,
      hintText: string.city,
      type: "City",
      options: "citySelectValue"
    },
    {
      label: string.zipOpen,
      hintText: string.zip,
      type: "Zip",
      options: "zipSelectValue"
    }
  ];
  return searchPopUpMap;
};

export const filterDataCRMFieldMapper = (field = null, receivedString) => {
  let string = _.clone(receivedString);
  if (_.isEmpty(string)) {
    string = {};
  }
  const filterMap = [
    {
      label: string.state,
      type: 'state',
      options: 'address1_stateorprovince',
      tab: 'both',
      hintText: string.state
    },
    {
      label: string.county,
      type: 'county',
      options: 'address1_county',
      tab: 'both',
      hintText: string.county
    },
    {
      label: string.city,
      type: 'city',
      options: 'address1_city',
      tab: 'both',
      hintText: string.city
    },
    {
      label: string.zip,
      type: 'zip',
      options: 'address1_postalcode',
      tab: 'both',
      hintText: string.zip
    },
    {
      label: string.leadtype,
      type: 'leadType',
      options: 'lead_type',
      tab: 'both',
      hintText: string.leadtype
    },
    {
      label: string.campaign,
      type: 'campaign',
      options: 'campaign',
      tab: 'both',
      hintText: string.campaign
    },
    {
      label: string.campaignType,
      type: 'campaignPurpose',
      options: 'campaignPurpose',
      tab: 'both',
      hintText: string.campaignType
    },
    {
      label: string.language,
      type: 'language',
      options: 'language_preference',
      tab: 'both',
      hintText: string.language
    },
    {
      label: string.lastassigned,
      type: 'lastAssigned',
      options: 'last_assigned',
      tab: '0',
      hintText: string.lastassigned
    },
    {
      label: string.assignedto,
      type: 'assignedTo',
      options: 'assignedTo',
      tab: '1',
      hintText: string.assignedto
    },
    {
      label: string.assignmentSource,
      type: 'assignmentSource',
      options: 'assignmentSource',
      tab: '1',
      hintText: string.assignmentSource
    },
    {
      label: string.sellingagent,
      type: 'lastSelling',
      options: 'last_selling',
      tab: '0',
      hintText: string.sellingagent
    },
    {
      label: string.disposition,
      type: 'disposition',
      options: 'disposition',
      tab: '1',
      hintText: string.disposition
    },
    {
      label: string.lineOneManager,
      type: 'lineOneManager',
      options: 'lineOneManager',
      tab: 'both',
      hintText: string.lineOneManager
    },
    {
      label: string.activeLastSellingAgentName,
      type: 'activeLastSellingAgentName',
      options: 'activeLastSellingAgentName',
      tab: 'both',
      hintText: string.activeLastSellingAgentName
    },
    {
      label: string.isOrphaned,
      type: 'isOrphaned',
      options: 'isOrphaned',
      tab: 'both',
      hintText: string.isOrphanedHintText
    },
    {
      label: string.tier,
      type: 'tier',
      options: 'tier',
      tab: 'both',
      hintText: string.tier
    },
  ];

  const filterMapManage = [
    {
      options: 'state',
      type: 'state'
    },
    {
      options: 'county',
      type: 'county'
    },
    {
      options: 'city',
      type: 'city'
    },
    {
      options: 'zip',
      type: 'zip'
    },
    {
      options: 'campaign',
      type: 'campaign'
    },
    {
      options: 'campaignPurpose',
      type: 'campaignPurpose'
    },
    {
      options: 'leadType',
      type: 'leadType'
    },
    {
      options: 'language',
      type: 'language'
    },
    {
      options: 'disposition',
      type: 'disposition'
    },
    {
      options: 'tier',
      type: 'tier'
    }
  ];
  
  if (field) {
    return __MANAGE__ ?
      _.find(filterMapManage, ['options', field]).type : _.find(filterMap, ['options', field]).type;
  }
  return filterMap;
};

export const dropDownData = (receivedString) => {
  let string = _.clone(receivedString);
  if (_.isEmpty(string)) {
    string = {};
  }
  const inspectionsOptionSet = {
    customerExperience: [
      { value: 1, label: string.poor },
      { value: 2, label: '2' },
      { value: 3, label: '3' },
      { value: 4, label: '4' },
      { value: 5, label: string.rich }
    ],
    noContactData: [
      { value: 1, label: string.leftmessage },
      { value: 2, label: string.badphonenumber },
      { value: 3, label: string.timeofsale },
      { value: 4, label: string.inspnotrequired },
      { value: 5, label: string.policyCancelled }
    ],
    trainingOpportunityData: [
      { value: 1, label: string.none },
      { value: 2, label: string.affordability },
      { value: 5, label: string.billingprocess },
      { value: 7, label: string.familybusiness },
      { value: 4, label: string.needsbasedselling },
      { value: 3, label: string.productknowledge },
      { value: 6, label: string.paymentmode }
    ]
  };
  return inspectionsOptionSet;
};

export const filterOptionsData = (column, customList) => {
  const list = customList;
  return list.map((item) => {
    const itemNew = item.split(' ');
    return {
      clearableValue: false,
      value: `${toTitleCase(itemNew[0])} ${itemNew[1] === undefined ? '' : itemNew[1]}`,
      label: `${toTitleCase(itemNew[0])} ${itemNew[1] === undefined ? '' : itemNew[1]}`,
    };
  });
};

export const filterPoliciesData = (customList) => {
  const list = customList;
  return list.map(item => (
    {
      clearableValue: false,
      value: `${item.fullname} | ${toTitleCase(item.name)}`,
      label: `${item.fullname} | ${toTitleCase(item.name)}`,
      disable: false
    }));
};

export const filterFooterOptionsData = (ownerid, customList, activeIndex) => {
  let list = customList && customList.map((item) => { //eslint-disable-line
    const itemWithoutExtraSpaces = item.fullname.replace(/  +/g, ' '); //eslint-disable-line
    const itemNew = itemWithoutExtraSpaces.split(' ');
    return {
      clearableValue: false,
      value: item.systemuserid,
      label: `${toTitleCase(itemNew[1])}, ${itemNew[0] === undefined ? '' : itemNew[0]} ${itemNew[2] === undefined ? '' : itemNew[2]}`
    };
  });
  if (activeIndex) {
    list.push({
      clearableValue: false,
      value: ownerid,
      label: 'Self'
    });
  }
  return list;
};

export const fetchPickListObject = pickList => (
  pickList.map(pickListRecord => (
    {
      label: pickListRecord.label,
      value: pickListRecord.value
    }
  ))
);

export const insertToCalendar = (data, conData) => {
  if (__MANAGE__ && !__CONFIG__.testManageApp) {
    const dataPayload = {
      modelName: 'cicaLeadsModel',
      eventData: data,
      contactData: conData
    };
    return new Promise((resolve, reject) => {
      handleAppEvent('INSERT_CAL_DATA', dataPayload).then((successData) => {
        if (successData.success !== undefined) {
          resolve(successData);
        } else {
          reject('Error adding event to calendar');
        }
      }, () => {
        reject('Error adding event to calendar');
      });
    });
  }
  return new Promise((resolve) => {
    resolve('success');
  });
};

export const getCustomerExperience = (data, receivedString) => {
  let string = _.clone(receivedString);
  if (_.isEmpty(string)) {
    string = {};
  }
  switch (data) {
    case 1:
      return string.poor;
    case 2:
      return '2';
    case 3:
      return '3';
    case 4:
      return '4';
    case 5:
      return string.rich;
    default:
      return '';
  }
};

export const getTrainingOpportunity = (value, receivedString) => {
  let string = _.clone(receivedString);
  if (_.isEmpty(string)) {
    string = {};
  }
  switch (value) {
    case 1:
      return string.none;
    case 2:
      return string.affordability;
    case 3:
      return string.productknowledge;
    case 4:
      return string.needsbasedselling;
    case 5:
      return string.billingprocess;
    case 6:
      return string.paymentmode;
    case 7:
      return string.familybusiness;
    default:
      return '';
  }
};
/*
 * Generates a 32 digit GUID that matches the CRM GUID uniqueness requirements
 */
export const generateGUID = () => {
  const guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    // var r = Math.random() * 16 | 0, //eslint-disable-line
    const crypto = window.crypto || window.msCrypto;
    var array = new Uint32Array(1);
    var r = crypto.getRandomValues(array) * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8); //eslint-disable-line
    return v.toString(16);
  });

  return guid;
};

export const updateCicaDraft = (data) => {
  const dataPayload = {
    modelName: 'draftsModel',
    updateData: data
  };
  return new Promise((resolve, reject) => {
    handleAppEvent('UPDATE_DATA_DRAFT', dataPayload).then((successData) => {
      if (successData !== undefined) {
        resolve(successData);
      } else {
        reject(new Error('No such record in DB'));
      }
    }, () => {
      reject(new Error('Error Retreiving Values from DB'));
    });
  });
};

export const fetchDraftsById = (policyId) => {
  const dataPayload = {
    modelName: 'draftsModel',
    query: `SELECT * FROM cica_drafts WHERE policy_number="${policyId}"`,
    picklistArray: []
  };
  return new Promise((resolve, reject) => {
    handleAppEvent('FETCH_DATA', dataPayload).then((successData) => {
      if (successData.data.length > 0) {
        resolve(successData);
      } else {
        reject('No Data in Drafts');
      }
    }, () => {
      reject('Error Retreiving Values from DB');
    });
  });
};


export const getStateCode = (state) => {
  const stateToCheck = state.toLowerCase();
  console.log('stateToCheck', stateToCheck);
  switch(stateToCheck) {
    case 'alabama':
      return 'AL';
    case 'alaska':
      return 'AK';
    case 'arizona':
      return 'AZ';  
    case 'arkansas':
      return 'AR';
    case 'california':
      return 'CA';
    case 'colorado':
      return 'CO';
    case 'connecticut':
      return 'CT';
    case 'delaware':
      return 'DE';
    case 'district of columbia':
      return 'DC';
    case 'florida':
      return 'FL';
    case 'georgia':
      return 'GA';
    case 'hawaii':
      return 'HI';
    case 'idaho':
      return 'ID';  
    case 'illinois':
      return 'IL';
    case 'indiana':
      return 'IN';
    case 'iowa':
      return 'IA';
    case 'kansas':
      return 'KS';
    case 'kentucky':
      return 'KY';
    case 'louisiana':
      return 'LA';
    case 'maine':
      return 'ME';
    case 'maryland':
      return 'MD';
    case 'massachusetts':
      return 'MA';
    case 'michigan':
      return 'MI';
    case 'minnesota':
      return 'MN';
    case 'mississippi':
      return 'MS';
    case 'missouri':
      return 'MO';
    case 'montana':
      return 'MT';
    case 'nebraska':
      return 'NE';
    case 'nevada':
      return 'NV';
    case 'new hampshire':
      return 'NH';
    case 'new jersey':
      return 'NJ';
    case 'new mexico':
      return 'NM';
    case 'new york':
      return 'NY';
    case 'north carolina':
      return 'NC';
    case 'north dakota':
      return 'ND';
    case 'ohio':
      return 'OH';
    case 'oklahoma':
      return 'OK';
    case 'oregon':
      return 'OR';
    case 'pennsylvania':
      return 'PA';
    case 'rhode island':
      return 'RI';
    case 'south carolina':
      return 'SC';
    case 'south dakota':
      return 'SD';
    case 'tennessee':
      return 'TN';
    case 'texas':
      return 'TX';
    case 'utah':
      return 'UT';
    case 'vermont':
      return 'VT';
    case 'virginia':
      return 'VA';
    case 'washington':
      return 'WA';
    case 'west virginia':
      return 'WV';
    case 'wisconsin':
      return 'WI';
    case 'wyoming':
      return 'WY';
    default:
      return '';
  }

};

export default formatDataForTableView;



// WEBPACK FOOTER //
// ./src/lib/utility.js